import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, firstValueFrom, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private readonly baseUrl = environment.base; // ej: '/api/v1' o 'http://localhost:3000/api/v1'

  constructor(protected http: HttpClient) {}

  private getHeaders(customHeaders?: { [key: string]: string }) {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // aquí luego se puede añadir Authorization si no usas interceptor
    });

    if (customHeaders) {
      Object.keys(customHeaders).forEach(key => {
        headers = headers.set(key, customHeaders[key]);
      });
    }
    return headers;
  }

  async get<T>(
    url: string,
    params?: HttpParams,
    headers?: any,
    withCredentials = false
  ): Promise<T> {
    const response$ = this.http.get<T>(`${this.baseUrl}/${url}`, {
      headers: this.getHeaders(headers),
      params,
      withCredentials,
    }).pipe(
      catchError(err => {
        // console.error('Error desde servicio:', err);
        return throwError(() => err);
      })
    );

    return await firstValueFrom(response$);
  }

  async post<T>(
    url: string,
    body: any,
    headers?: any,
    withCredentials = false
  ): Promise<T> {
    const response$ = this.http.post<T>(`${this.baseUrl}/${url}`, body, {
      headers: this.getHeaders(headers),
      withCredentials,
    }).pipe(
      catchError(err => {
        
        return throwError(() => err);
      })
    );

    return await firstValueFrom(response$);
  }

  async put<T>(
    url: string,
    body: any,
    headers?: any,
    withCredentials = false
  ): Promise<T> {
    const response$ = this.http.put<T>(`${this.baseUrl}/${url}`, body, {
      headers: this.getHeaders(headers),
      withCredentials,
    }).pipe(
      catchError(err => {
      
        return throwError(() => err);
      })
    );

    return await firstValueFrom(response$);
  }

  async delete<T>(
    url: string,
    headers?: any,
    withCredentials = false
  ): Promise<T> {
    const response$ = this.http.delete<T>(`${this.baseUrl}/${url}`, {
      headers: this.getHeaders(headers),
      withCredentials,
    }).pipe(
      catchError(err => {
        
        return throwError(() => err);
      })
    );

    return await firstValueFrom(response$);
  }
}
